import { createApi } from '@reduxjs/toolkit/query/react'
import { getBaseQuery, getBaseUrl } from '../../Utils'
import { createSlice, PayloadAction } from '@reduxjs/toolkit';



interface ShowStatCaseFormPayload {
    vuId: string;
    accessionNumber: string;
    isCerner: boolean;
}

const baseUrl = `${getBaseUrl()}/API/v3/ActivePanel`

export const StatCaseAPI = createApi({
    reducerPath: 'StatCaseAPI',
    baseQuery: getBaseQuery(baseUrl),
    endpoints: (builder) => ({
        RunWorklistManager: builder.mutation<any, any>({
            query: (reqRunVUData) => ({
                url: '/RunWorklistManager',
                method: 'POST',
                body: reqRunVUData,
                headers: {
                    'Content-Type': 'application/json',
                },
            }),
        }),
        RunActivePanel: builder.mutation<any, any>({
            query: (reqRunVUData) => ({
                url: '/RunActivePanel',
                method: 'POST',
                body: reqRunVUData,
                headers: {
                    'Content-Type': 'application/json',
                },
            }),
        }),
        RunGetStatCase: builder.mutation<any, any>({
            query: (reqRunVUData) => ({
                url: '/RunGetStatCase',
                method: 'POST',
                body: reqRunVUData,
                headers: {
                    'Content-Type': 'application/json',
                },
            }),
        }),
    }),
})
interface StatCaseState {
    loading: boolean;
    successMessage?: string;
    errorMessage?: string;
    isOpen: boolean;
    vuId: string | null;
    accessionNumber: string | null;
    isCerner: boolean;
}

const statCaseInitialState: StatCaseState = {
    loading: false,
    successMessage: undefined,
    errorMessage: undefined,
    isOpen: false,
    vuId: null,
    accessionNumber: null,
    isCerner: false
};

const statCaseSlice = createSlice({
    name: 'statCase',
    initialState: statCaseInitialState,
    reducers: {
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setSuccessMessage: (state, action: PayloadAction<string | undefined>) => {
            state.successMessage = action.payload;
        },
        setErrorMessage: (state, action: PayloadAction<string | undefined>) => {
            state.errorMessage = action.payload;
        },
    },
});

export const { setLoading, setSuccessMessage, setErrorMessage} = statCaseSlice.actions;

export default statCaseSlice;

export const { useRunWorklistManagerMutation, useRunActivePanelMutation, useRunGetStatCaseMutation } = StatCaseAPI
